import { useRef, useCallback } from 'react';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export function useRecaptcha(onVerify, containerId) {
  const widgetIdRef = useRef(null);

  const renderCaptcha = useCallback(() => {
    if (!RECAPTCHA_SITE_KEY) return;
    const container = document.getElementById(containerId);
    if (!container || widgetIdRef.current !== null) return;
    if (!window.grecaptcha) return;
    window.grecaptcha.ready(() => {
      if (widgetIdRef.current !== null) return;
      widgetIdRef.current = window.grecaptcha.render(containerId, {
        sitekey: RECAPTCHA_SITE_KEY,
        callback:          onVerify,
        'expired-callback': () => onVerify(''),
        'error-callback':   () => onVerify(''),
      });
    });
  }, [containerId, onVerify]);

  return { renderCaptcha, widgetIdRef, captchaRequired: !!RECAPTCHA_SITE_KEY };
}
